<template lang="pug">
  v-content(class="fundo")
    v-container(fluid class="bloco_imagem_topo")
      v-layout(row wrap)
        iframe(id="frmmapa" class="imagem_topo" width="100%" height="600" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" :src="link")
              
        v-flex(xs2)       
        v-flex(xs2)
          v-card(flat v-for="item in locais" v-if="item.id < 4" :key="item.id")
            v-card-title(class="texto_titulo2" v-html="item.local")
            v-card-text(class="texto1" v-html="item.dresscontact")
        v-flex(xs2)
          v-card(flat v-for="item in locais" v-if="item.id > 3 && item.id < 7" :key="item.id")
            v-card-title(class="texto_titulo2" v-html="item.local")
            v-card-text(class="texto1" v-html="item.dresscontact")
        v-flex(xs2)
          v-card(flat v-for="item in locais" v-if="item.id > 6" :key="item.id")
            v-card-title(class="texto_titulo2" v-html="item.local")
            v-card-text(class="texto1" v-html="item.dresscontact")        
        v-flex(xs2)

          form(method="post" action="" v-on:submit.prevent="enviar" enctype="multipart/form-data")
            v-layout(row wrap)
              v-flex(xs12 offset-xs2 class="hidden-sm-and-down")
                v-card(flat)                
                  v-card-text(class="texto_titulo") FALE CONNOSCO
                  span(class="separator2")
            v-layout(row wrap)
              v-flex(xs12 offset-xs2)
                v-text-field(name="nome" v-model="nome" label="Nome" v-validate.initial="'required|alpha_spaces'" type="text" class="{'input': true, 'is-danger': errorvee.has('nome') }" hide-details )
                //- v-text-field(name="nome" v-model="nome" label="Nome" type="text" hide-details )
                span(v-show="errorvee.has('nome')" class="help is-danger") {{ errorvee.first('nome') }}
                br
            v-layout(row wrap)
              v-flex(xs12 offset-xs2)
                v-text-field(name="telefone" v-model="telefone" label="Telefone" v-validate.initial="'numeric'" type="text" class="{'input': true, 'is-danger': errorvee.has('telefone') }" hide-details )
                //- v-text-field(name="telefone" v-model="telefone" label="Telefone" type="text" hide-details )
                span(v-show="errorvee.has('telefone')" class="help is-danger") {{ errorvee.first('telefone') }}
                br
            v-layout(row wrap)
              v-flex(xs12 offset-xs2)
                v-text-field(name="email" v-model="email" label="E-mail" v-validate.initial="'required|email'" type="text" class="{'input': true, 'is-danger': errorvee.has('email') }" @rules="[rules.required, rules.email]")
                //- v-text-field(name="email" v-model="email" label="E-mail" type="text" :rules="[rules.required,rules.email]")
                span(v-show="errorvee.has('email')" class="help is-danger") {{ errorvee.first('email') }}
                br
            v-layout(row wrap)
              v-flex(xs12 offset-xs2)
                v-textarea(v-model="texto" label="Texto" multi-line)
            v-layout(row wrap)
              p
                v-btn(class="botao" flat type="submit") Enviar &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
                //- v-btn(title="FICHEIRO" accept=".pdf" v-bind:selectedCallback="enviar")
                //-   span(class="texto1") ENVIAR &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp >
                //-img(v-bind:src="anexo" style="max-width: 20%")
                br
                br

        v-flex(xs2)

    v-footer(class="footer")
      v-flex(xs12)
        v-layout(justify-center row wrap)
          v-layout(justify-center row wrap)
            v-btn(flat v-for="item in menu" :key="item.id" v-on:click="$emit('onChangeComponent',item.comp)" class="footerlinks") {{ item.title }}
        v-layout(justify-center row wrap)
        v-layout(justify-center row wrap)
          v-flex(xs1)
          v-flex(xs3)
            v-layout(justify-center row wrap)        
              p
              br
              p(class="texto_fundo2") </br></br></br>© 2019 Luis S. Rodrigues & Associados. All Rights Reserved.      
          v-flex(xs8)            
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<script>

  export default {
    name: 'contactos',
    data: () => ({
      formok: false,
      nome: '',
      telefone: '',
      email: '',
      texto: '',      
      rules: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'}
        },
      link: "/lsr_iframe_map2.php",
      menu: [    
        { id: '1', title: 'Apresentação', comp: 'apresentacao'},
        { id: '2', title: 'Áreas de Actividade', comp: 'areas_actividade'},
        { id: '3', title: 'Advogados', comp: 'advogados'},
        { id: '4', title: 'Contactos', comp: 'contactos'}         
      ],      
      locais:[
        { id: 1, local: 'LISBOA', dresscontact: 'Campo Grande, 28-6ºA </br>1700-093 Lisboa </br>Tel: +351 217 969 712 </br>Fax: +351 217 938 973 </br>lsr-lisboa@pratica-legal.com'
            , latitude: '38.749759', longitude: '-9.148126'},            
        { id: 2, local: 'PORTO', dresscontact: 'Praça do Bom Sucesso, 61 -604 </br>4150-146 Porto </br>Tel: +351 225 430 751 </br>Fax: +351 226 000 443 </br>lsr-porto@pratica-legal.com'
            , latitude: '41.155280', longitude: '-8.629300'},
        { id: 3, local: 'BUENOS AIRES', dresscontact: 'Avda. Almafuerte 841/5 PB </br>1437 JLI – Nueva Pompeya Buenos Aires (Argentina) </br>TFNO: (51-11) 4912-1810 </br>FAX: (51-11) 4912-1878'
            , latitude: '-34.6473475', longitude: '-58.4180679'},
        { id: 4, local: 'MADRID', dresscontact: 'Paseo de la Castellana 179-3ºC  </br>28046 Madrid  </br>Tel: +34 91 570 54 57  </br>Fax: +34 91 579 03 75  </br>madrid@mad.practica-legal.com'
            , latitude: '40.462951', longitude: '-3.689695'},
        { id: 5, local: 'VALENCIA', dresscontact: 'C/Poeta Josep Cerverah Grifol 12,2º,5º </br>46012 Valencia </br>Tel: +34 96 333 76 32 </br>Fax: +34 96328 08 00 </br>valencia@val.practica-legal.com'
            , latitude: '39.454719', longitude: '-0.357974'},
        { id: 6, local: 'BARCELONA', dresscontact: 'Avenida Diagonal 511, Entresuelo de Barcelona </br>08029 Barcelona </br>Tel: +34 93 430 56 57 </br>Fax: +34 93 430 00 12 </br>barcelona@bar.practica-legal.com'
            , latitude: '41.393560', longitude: '2.147941'},
        { id: 7, local: 'LA CORUÑA', dresscontact: 'C/Juana de vega, 9-3º </br>15004 La Coruña </br>Tel: +34 98 1 22 89 39 </br>Fax: +34 98 1 22 88 86 </br>galicia@gal.practica-legal.com'
            , latitude: '43.366701', longitude: '-8.405522'},
        { id: 8, local: 'C. LA MANCHA', dresscontact: 'C/Pintor Mendoza 29, </br>13300 Valdepeñas, Ciudad Real (España) </br>Tfno: +34 92 63 12 186 </br>Fax: +34 92 63 21 416 </br>clm@clm.practica-legal.com'
            , latitude: '38.7694875', longitude: '-3.3960436'},
      ],      
    }),

    methods:{
      // onChangeLocal(local){
      //   this.latitude = this.locais[local-1].latitude
      //   this.longitude = this.locais[local-1].longitude
      //   //this.initialize_map
      //   this.localID = this.locais[local-1].id
      // },
      enviar(){
           this.$validator.validateAll().then(() => {
          //this.$refs.form.validate();
          //if(this.formok==true) {
            let fdata = new FormData();
            fdata.append("nome", this.nome);
            fdata.append("telefone", this.telefone);
            fdata.append("email", this.email);
            fdata.append("texto", this.texto);
            
            // eslint-disable-next-line
            this.$http.post('/gomail.php', fdata).then(response => {
                alert("Pedido submetido. Obrigado.")
                this.formok = false
              }, response => {
                alert("Erro! " + response.error)
              });
          // }else{
          //    alert('Temporariamente indisponível!');
          }).catch(() => {
            alert('Corrija os erros indicados!');
          });
          //}
      },
    },

   mounted: function () {
         this.$nextTick(function () {
            window.scrollTo(0, 0)
         })
    }



  }
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<style>
</style>
